import { z } from "zod";

export const contextTagsSchema = z
  .object({
    tags: z.array(z.string()).default([]),
  })
  .nullable()
  .transform((value) => (value === null ? [] : value.tags));
